import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { apple, thunderBird } from '../Colors/Colors';
import { SIZE } from './Constants';
import { ValidationRequiredIcon } from '@parchment/icons';
const StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "Label__StyledLabel",
  componentId: "sc-13lay53-0"
})(["font-size:", " font-weight:600;white-space:nowrap;overflow:hidden;&.valid{color:", ";}&.invalid{color:", ";}"], props => {
  const fontSize = {
    small: '13',
    medium: '13',
    large: '16'
  };
  return "".concat(fontSize[props.size], "px;");
}, apple, thunderBird);
StyledLabel.displayName = 'StyledLabel';
export const Label = function (props) {
  const {
    required,
    touched,
    valid
  } = props;
  let validClass = '';

  if (touched) {
    validClass = valid ? 'valid' : 'invalid';
  }

  return /*#__PURE__*/React.createElement(StyledLabel, {
    className: validClass,
    size: props.size
  }, required && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ValidationRequiredIcon, {
    color: thunderBird
  }), " "), props.children);
};
Label.propTypes = {
  size: PropTypes.oneOf([SIZE.small, SIZE.medium, SIZE.large]),
  required: PropTypes.bool,
  touched: PropTypes.bool,
  valid: PropTypes.bool,
  children: PropTypes.node
};
Label.defaultProps = {
  size: SIZE.medium
};